import * as React from "react";
import { OAuth2Client } from "google-auth-library";
import camelize from "camelize-ts";

import { Authorization, AppContextRole } from "../types";

import keys from "./oauth2.keys.json";
import useReload from "./useReload";
import useServiceSetup from "./useServiceSetup";
import useIsAuthorized from "../common/hooks/useIsAuthorized";

export const oAuth2Client = new OAuth2Client(
  keys.web.client_id,
  keys.web.client_secret,
  keys.web.redirect_uris[0]
);

function useAuthorizeWithParams() {
  const reload = useReload("useAuthorizeWithParams");
  const { setup } = useServiceSetup();
  const isAuthorized = useIsAuthorized();

  const authorizationParams = React.useMemo<{ code: string } | null>(() => {
    const params = new URLSearchParams(window.location.search);

    let data: {
      code?: string;
    } = {};

    params.forEach((value, key) => {
      data = { ...data, [key]: value };
    });

    const { code } = data;
    if (code) {
      return { code };
    }

    return null;
  }, []);

  React.useEffect(() => {
    const authorizeWithCode = async (code: string) => {
      try {
        const { tokens: authTokens } = await oAuth2Client.getToken(code);
        const tokens = camelize(authTokens) as Authorization;

        if (tokens) {
          await setup({ role: AppContextRole.Instructor, tokens });
          window.location.replace(window.location.origin);
        }
      } catch (err) {
        console.log("err = ", err);
      } finally {
      }
    };

    if (!isAuthorized && authorizationParams && "code" in authorizationParams) {
      authorizeWithCode(authorizationParams.code);
    }
  }, [authorizationParams, reload, isAuthorized]);
}

export default useAuthorizeWithParams;
